// extracted by mini-css-extract-plugin
export default {"tag":"SkillTag_tag__c-YhX"};